var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import * as S from './style';
import BlobWithCircle from '../blob-with-circle';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import Image from '../../../components/loggedout/common/Image';
import { assignAbTestsToUser, convertToUUIDFormat, fetchImageUrlForNewOnboarding, getItemFromLocalStorage, sendEventUsingAvo } from '../../../utils/web-helper';
import { GetAgeBasedSurvey } from '../../../services/loggedout-api';
import { FetchNewABTests, SetGradeApi } from '../../../services/parent-api';
import { setNewABTests } from '../../../utils/ab-tests';
import { useDispatch } from 'react-redux';
import { setSelectedGrade } from '../../../stores/splashverse-onboarding/actions';
import { UserOnboardingDetails } from '../../../services/parent-api';
import { PRE_K_GRADE, K_GRADE, AGE_FIVE } from '../../../constant-data/constants';
import i18n from '../../../utils/i18n';
export var ProgramDescriptionScreen = function (props) {
    var _a = useState({
        age: 0,
        heading: "",
        options: [{
                topics: [],
                images: []
            }]
    }), filteredTopicData = _a[0], setFilteredTopicData = _a[1];
    var _b = useState([false, false, false, false]), blobActiveStates = _b[0], setBlobActiveStates = _b[1];
    var _c = useState([]), allTopicsData = _c[0], setAllTopicsData = _c[1];
    var _d = useState(false), isDataLoaded = _d[0], setDataLoaded = _d[1];
    var childName = getItemFromLocalStorage('tutoringChildName');
    var _e = useExtendedLocalStorage('splashverse-onboarding', ''), getItem = _e.getItem, setValue = _e.setValue;
    var dispatch = useDispatch();
    var selectedAge = getItem('selectedAge');
    var selectedGrade = selectedAge == AGE_FIVE ? K_GRADE : PRE_K_GRADE;
    var ageTitleMapping = {
        '2': i18n.t("age.2"),
        '3': i18n.t("age.3"),
        '4': i18n.t("age.4"),
        '5': i18n.t("age.5")
    };
    var BlobsPositioningAndDataMapping = [
        {
            rotate: 0,
            id: '2',
            displayAge: 2
        },
        {
            rotate: 3,
            id: '3',
            displayAge: 3
        },
        {
            rotate: 2,
            id: '4',
            displayAge: 4
        },
        {
            rotate: 1,
            id: '5',
            displayAge: 5
        }
    ];
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadProgramData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); })();
        sendEventUsingAvo({ methodName: 'viewedProgramDetailsScreen', params: {} });
    }, []);
    useEffect(function () {
        var selectedAgeData = allTopicsData && allTopicsData.find(function (data) { return data.age === parseInt(selectedAge); });
        if (allTopicsData && selectedAgeData) {
            var optionsArray = Object.keys(selectedAgeData.options).map(function (data) { return selectedAgeData.options[data]; });
            var optionsTopic = optionsArray.map(function (option) { return option.heading; });
            var optionsImage = optionsArray.map(function (option) { return option.image; });
            var TopicsAndImages = [{
                    topics: optionsTopic,
                    images: optionsImage
                }];
            var filteredData = {
                age: selectedAgeData.age,
                heading: selectedAgeData.heading,
                options: TopicsAndImages,
            };
            setFilteredTopicData(filteredData);
        }
    }, [blobActiveStates]);
    var loadProgramData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, params;
        return __generator(this, function (_a) {
            params = { code: 'program_description_based_on_age' };
            try {
                response = GetAgeBasedSurvey(params).then(function (res) {
                    setAllTopicsData(res.surveys);
                    setDataLoaded(true);
                });
            }
            catch (e) {
                console.error(e);
            }
            return [2 /*return*/];
        });
    }); };
    var blobClickHandler = function (id, index) {
        setValue('selectedAge', id);
        var updatedStates = [false, false, false, false];
        updatedStates[index] = !updatedStates[index];
        setBlobActiveStates(updatedStates);
        sendEventUsingAvo({ methodName: 'interactedProgramDetailsScreen', params: { 'clickedOn': "Age ".concat(id) } });
    };
    var proceedToNextScreen = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resp, newAbTests, childId, opt;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, SetGradeApi({
                        grade_code: selectedGrade,
                        student_id: props.students && props.students.length && props.students[0].id ? props.students[0].id : null,
                        onboarding: true,
                        screen_name: childName,
                        age: selectedAge
                    })];
                case 1:
                    resp = _c.sent();
                    return [4 /*yield*/, assignAbTestsToUser((_a = props.currentUser) === null || _a === void 0 ? void 0 : _a.id, selectedGrade)];
                case 2:
                    _c.sent();
                    return [4 /*yield*/, FetchNewABTests({ userId: convertToUUIDFormat((_b = props.currentUser) === null || _b === void 0 ? void 0 : _b.id) })];
                case 3:
                    newAbTests = _c.sent();
                    setNewABTests(newAbTests === null || newAbTests === void 0 ? void 0 : newAbTests.assigned_ab_tests);
                    childId = resp && resp.student && resp.student.id || props.students && props.students.length && props.students[0].id;
                    // //set child id in local storage
                    childId && setValue('childId', childId);
                    setValue('selectedGrade', selectedAge == AGE_FIVE ? K_GRADE : PRE_K_GRADE);
                    dispatch(setSelectedGrade(selectedAge == AGE_FIVE ? K_GRADE : PRE_K_GRADE));
                    sendEventUsingAvo({ methodName: 'interactedProgramDetailsScreen', params: { 'clickedOn': 'Next' } });
                    opt = {};
                    props.goToNextHandler('program_description_screen', opt);
                    UserOnboardingDetails({
                        id: childId,
                        grade_code: selectedAge == AGE_FIVE ? K_GRADE : PRE_K_GRADE,
                        age: selectedAge,
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    // CDN image path for program description screen
    var imagePath = "/assets/new_onboarding/program_description_screen/";
    var fetchHeadingText = function (heading) {
        var updatedHeading = heading.replace("<c_name>", childName);
        return updatedHeading;
    };
    return (_jsxs(_Fragment, { children: [_jsxs(S.Heading, { children: ["How old is ", childName, "?"] }), _jsxs(S.SubHeading, { children: ["This information will help us tailor the program to ", childName, "'s needs"] }), isDataLoaded &&
                _jsxs(S.TVWrapper, { children: [_jsx(S.AgeTitle, { children: ageTitleMapping[selectedAge] }), _jsxs(S.ProgramDescriptionWrapper, { children: [_jsx(S.ProgramHeading, { children: fetchHeadingText(filteredTopicData.heading) }), _jsx(S.TopicsWrapper, { children: _jsxs(S.TopicWrapper, { children: [_jsx(S.TopicIconWrapper, { children: filteredTopicData.options[0].images.map(function (image, index) { return (_jsx(S.TopicIcon, { children: _jsx(Image, { src: (fetchImageUrlForNewOnboarding(imagePath, image)), alt: "topic-icon" }) }, index)); }) }), _jsx(S.TopicTextWrapper, { children: filteredTopicData.options[0].topics.map(function (topic, index) { return (_jsx(S.TopicText, { children: topic }, index)); }) })] }) })] }), _jsx(S.BlobsWrapper, { children: BlobsPositioningAndDataMapping.map(function (data, index) { return (_jsx(BlobWithCircle, { blobData: data, index: index, blobClickHandler: blobClickHandler, pdsScreen: true, isBlobActive: blobActiveStates[index], setBlobActive: function (value) {
                                    setBlobActiveStates(function (prevStates) { return prevStates.map(function (prevState, i) { return i === index ? value : prevState; }); });
                                }, selectedAge: selectedAge })); }) })] }), _jsxs(S.CTAWrapper, { children: [_jsxs(S.Footer, { children: [childName, " is ", selectedAge, " years old"] }), _jsx(S.CTAButton, __assign({ onClick: proceedToNextScreen }, { children: "Next" }))] })] }));
};
export default ProgramDescriptionScreen;
